import * as types from '../constants/changePasswordConstants';
const LOGOUT_SUCCESS = 'neo-trading/auth/LOGOUT_SUCCESS';
import i18next from 'i18next';
const initialState = {
  loading: false,
  loaded: false,
   user: {
     oldpass:null,
     newpass: null,
     confpass:null,
     status: 'failure',
  },
  message:'',
  changePassStatus:true,
  isOTPSent: false,
  isAuthenticated: true,
  isOTPVerified: false,
  isOTPResent: false,
  OTPStatusCode: null
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
     case types.SUCCESS_DEFAULT:
       return {
         ...state,
       };
     case types.FAILURE_DEFAULT:
       return {
         ...state,
      };

      case types.FORGOT_PASS:
        return {
          ...state,
          isOTPSent: false
        }
      case types.FORGOT_PASS_SUCCESS:
        return {
          ...state,
          isOTPSent: true,
          OTPExpiryTime: action.result.dataObject.otpExpTS,
          OTPResendExpiryTime: action.result.dataObject.otpResendExpTS,
        }
      case types.FORGOT_PASS_FAILURE:
        return {
          ...state,
          isOTPSent: false,
          isAuthenticated: action.result ? action.result.status : action.error.status
        }
      case types.VERIFY_OTP:
        return {
          ...state,
          isOTPVerified: false
        }
      case types.VERIFY_OTP_SUCCESS:
        return {
          ...state,
          isOTPVerified: true,
          OTPStatusCode: action.result ? action.result.errCode : action.error.errCode
        }
      case types.VERIFY_OTP_FAILURE:
        return {
          ...state,
          isOTPVerified: false,
          OTPStatusCode: action.result ? action.result.errCode : action.error.errCode
        }
      case types.RESEND_OTP:
        return {
          ...state,
          isOTPResent: false
        }
      case types.RESEND_OTP_SUCCESS:
        return {
          ...state,
          isOTPResent: true,
          OTPStatusCode: action.result ? action.result.errCode : action.error.errCode
        }
      case types.RESEND_OTP_FAILURE:
        return {
          ...state,
          isOTPResent: false,
          OTPStatusCode: action.result ? action.result.errCode : action.error.errCode
        }
      case types.RESET_PASSWORD:
        return {
          ...state,
          isOTPResent: false
        }
      case types.RESET_PASSWORD_SUCCESS:
        return {
          ...state,
          isOTPResent: true,
          OTPStatusCode: action.result ? action.result.errCode : action.error.errCode
        }
      case types.RESET_PASSWORD_FAILURE:
        return {
          ...state,
          isOTPResent: false,
          OTPStatusCode: action.result ? action.result.errCode : action.error.errCode
        }
      case types.CLOSE_MODAL:
        return {
          ...state,
          isAuthenticated: true,
          isOTPSent: false,
          OTPStatusCode: null,
          isOTPVerified: false
        }
      case types.LOAD_CHANGE_PASSWORD:
      return {
        ...state,
        loaded: true,
        user: action.result,
        changePassStatus:true
      };
      case types.LOAD_CHANGE_PASSWORD_FAILURE:
        return {
          ...state,
            message: errorMessage(action.result.errCode),
            error: action.result.errCode,
            loaded: false,
            changePassStatus:false
            //showPopup: false
        };
        case types.LOAD_CHANGE_PASSWORD_SETTING:
          return {
            ...state,
            message:''
          };
          case types.LOAD_CHANGE_PASSWORD_SETTING_SUCCESS:
          return{
            ...state,
            message:errorMessage(action.result.errCode)

          };
          case types.LOAD_CHANGE_PASSWORD_SETTING_FAILURE:
            return {
              ...state,
                message: errorMessage(action.result.errCode),
                error: action.result.errCode,
                //showPopup: false
            };
          case LOGOUT_SUCCESS:
                return {
                ...state,
                message:''
              };
          case types.BLANK_MSG:
            return {
              ...state,
              message:''
            };
    default:
      return state;
  }
}
export function errorMessage(msg) {
let errorMsg;
switch (msg) {
  case 0:
  errorMsg = "Incorrect Old Password.";
  break
  case 1:
  errorMsg = "Password should be different from last 3 Passwords.";
  break
  case 2:
  errorMsg = "Password reset successfully.";
  break
  default:
  errorMsg = "Password reset failed. Please try again.";
  };
  return errorMsg;
  }
